import {
  REQUEST_GET_IMAGE_BY_ID,
  RECEIVE_GET_IMAGE_BY_ID_SUCCESS,
  RECEIVE_GET_IMAGE_BY_ID_FAILURE,
} from '../actions/actionTypes';

import initialState from './initialState';

export default function imageReaderReducer(state = initialState.imageReader, action) {
  switch (action.type) {
    case REQUEST_GET_IMAGE_BY_ID:
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    case RECEIVE_GET_IMAGE_BY_ID_SUCCESS:
      return {
        ...state,
        isFetching: false,
        images: action.images,
        lastUpdated: action.receivedAt,
      };
    case RECEIVE_GET_IMAGE_BY_ID_FAILURE:
      return {
        ...state,
        isfetching: false,
        error: action.error,
      };
    default:
      return state;
  }
}
